import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TherapistGroupService } from '../../../therapist-group.service';
import {
  ITherapistGroupBase,
  THERAPIST_GROUP_TTL_ES
} from '../../../therapist-group.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
@Component({
  selector: 'pg-therapist-group-create',
  templateUrl: './therapist-group-create.component.html'
})
export class TherapistGroupCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: TherapistGroupService
  ) {
    super(THERAPIST_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      description: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }

  onSubmit() {
    this.createItem$(this.fg.value as ITherapistGroupBase);
  }
}
